import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class ComplaintTitleBar extends Component {

    render() {
        return (
            <div className="row">
                <div className="col-md-4">
                    <div className="title-1 text-align-left">
                        <FormattedMessage id="app.admin-complaint-title-bar.title"
                                          defaultMessage="Quality Complaints"
                                          description=""/>
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4">&nbsp;</div>
                            <div className="col-md-3 text-right no-margin no-padding">
                                <label>
                                    <FormattedMessage id="app.admin-inquiry-title-bar.filter-by"
                                                      defaultMessage="Filter By:"
                                                      description=""/>
                                </label>&nbsp;&nbsp;&nbsp;&nbsp;

                            </div>
                            <div className="col-md-2 no-padding-left">
                                <FormattedMessage id="app.admin-complaint-title-bar.customer"
                                                  defaultMessage="Customer"
                                                  description=""/>
                            </div>
                            <div className="col-md-3 pull-left  no-padding-left ">
                                <input className="form-control search-input color-text" onChange={this.props.setSearchText}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ComplaintTitleBar;


// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/ComplaintTitleBar/ComplaintTitleBar.js